module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"filters":"Filter","resetFilters":"Filter zurücksetzen"},"en":{"filters":"Filters","resetFilters":"Reset filters"}}')
  delete Component.options._Ctor
}
